import type { Schema } from '@cli-types/core-engine/schema.js'
import { isColumnType } from '@core-engine/schema/field-type-guards/is-column-type.js'

export function collectInvalidColumnTypeErrors(schema: Schema, errors: string[]): void {
  for (const column of schema.columns || []) {
    if (
      column.type !== undefined &&
      (typeof column.type !== 'string' || !isColumnType(column.type))
    ) {
      errors.push(
        `Column "${column.accessorKey || 'unnamed'}" has unsupported type "${String(column.type)}".`
      )
    }
  }
}
